module.exports = __webpack_public_path__ + "static/media/Andrei_Duvin.1aeaef26.jpg";